
<template>
    <div class="signUp">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="row margin-top">
                        <div class="col-md-7">
                            <div class="main-content text-left left-content">
                                <hr>
                                <h2>
                                    Welcome to TONE. You are here to Manage your Community Page
                                </h2>
                            </div>
                            <div class="left-content">
                                <accordion :one-at-atime="true" type="danger">
                                <panel  type="danger" class="text-left">
                                    <strong slot="header"><h4>Download</h4></strong>
                                    <div class="create-account">
                                     <br>
                                        <button class="btn formButton btn-block" type="button" @click="downloadWithAxios">
                                            Download List
                                        </button>
<!--                                        <h5>Click <a href="javascript;" @click="downloadWithVueResource()">here</a> here to Download List of Users</h5>-->
                                 </div>
                                </panel>
                                <panel header="Panel #2" type="danger" class="text-left">
                                    <strong slot="header"><h4>Upload</h4></strong>
                                    <div class="create-account">
                                        <h5 class="margin-bot-20">Select CSV File</h5>
                                        <div class="clearfix gap"></div>
                                        <input ref="myFileInput" class="btn btn-primary" type="file" accept=".csv" @change="onFileChange" id="manageCoprPage">
                                        <button class="btn formButton btn-block" :disabled="csv_file.length === 0" type="button" @click="uploadImage">
                                            Upload
                                        </button>

                                    </div>
                                </panel>
                                </accordion>

<!--                                <accordion >-->
<!--                                    <panel :is-open="true"  class="text-left">-->
<!--                                        <h4>Download List of Users</h4>-->
<!--                                        <div class="create-account">-->
<!--                                            <br>-->
<!--                                        </div>-->
<!--                                    </panel>-->
<!--                                    <panel class="text-left">-->
<!--                                        <h4>Upload File to update meta data</h4>-->
<!--                                    </panel>-->
<!--                                </accordion>-->
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="right-content">
                                <div class="jumbotron">
                                    <div><h2>{{user.corporation.name}}</h2><p>{{user.firstName}}&nbsp;{{user.lastName}}&nbsp;(Admin)</p></div>
<!--                                    <div class="showmobile"><h2>What You Get</h2></div>-->
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="card">
                                    <!--<div class="card-header text-center">-->
                                        <!--<h3>-->
                                            <!--YOUR PLAN-->
                                        <!--</h3>-->
                                    <!--</div>-->
                                    <div class="card-block">
                                        <div class="list-group">
                                            <div class="card-footer hidemobile" >
                                                <div class="list-group">
                                                    <li class="list-group-item">
                                                        <strong>Tips to Upload/Download CSV Files</strong>
                                                        <!--<input type="radio" name = "pkg" :value="defaultPlan.packageId" v-model="packageId" :checked="defaultPlan.packageId == packageId" />&nbsp;&nbsp;<strong>{{ defaultPlan.type }}</strong> (${{defaultPlan.amount}}) - {{defaultPlan.description}}-->
                                                    </li>
                                                </div>
                                            </div>
                                            <br>
                                            <li> Download File => To get list of users in {{user.corporation.name}}
                                                <!--Personalized bite-sized expert videos will inspire you and set a positive TONE to your day-->
                                            </li>
                                            <li> Add attribues to users from downloaded file
                                                <!--Personalized bite-sized expert videos will inspire you and set a positive TONE to your day-->
                                            </li>
                                            <li> Upload File => To synchronize changes in users with our records
<!--                                                <span class="icon-info-circled alert-icon-float-left information password-error"></span>-->
                                                <!--Personalized bite-sized expert videos will inspire you and set a positive TONE to your day-->
                                            </li>
                                            <br />
                                            <div class="alert alert-danger" role="alert">
                                                <h6 class="text-uppercase">Note: First column of file should always be 'email'</h6>
                                            </div>
<!--                                            <li class="hidemobile" v-if="dynamic_bullet_2" v-html="dynamic_bullet_2">-->
<!--                                                &lt;!&ndash;A little dose of humor, and a pinch of inspiration each time you log on&ndash;&gt;-->
<!--                                            </li>-->
<!--                                            <li v-if="dynamic_bullet_3" v-html="dynamic_bullet_3">-->
<!--                                                &lt;!&ndash;Reserve your spot for TONE Live... exclusive live streaming events with our credentialed expert&ndash;&gt;-->
<!--                                            </li>-->
<!--                                            <li v-if="dynamic_bullet_4" v-html="dynamic_bullet_4">-->
<!--                                                &lt;!&ndash;Tune in to TONE Talks... our moderated discussions every Tuesday and Thursday night where we share advice within our community of women helping women!&ndash;&gt;-->
<!--                                            </li>-->
<!--                                            <li v-if="dynamic_bullet_5" v-html="dynamic_bullet_5">-->
<!--                                                &lt;!&ndash;And did we mention you will be helping out a&ndash;&gt;-->
<!--                                                &lt;!&ndash;charity every time you use the site?&ndash;&gt;-->
<!--                                            </li>-->
<!--                                            <li v-if="dynamic_bullet_6" v-html="dynamic_bullet_6">-->
<!--                                                &lt;!&ndash;Look out for TONE Teasers... customized emails with videos selected just for you!&ndash;&gt;-->
<!--                                            </li>-->
                                            <!--<li v-if="!codeRedeemed" class="hidemobile">Try out TONE! Get a {{defaultPlan.type}} trial with your monthly membership, or {{annualPlan.type}} when you sign up for a year.</li>-->
                                            <!--<li v-if="!codeRedeemed" class="showmobile">Enjoy your free trial!</li>-->
                                        </div>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { input, spinner, accordion, panel, alert, dropdown, radio, checkbox, tabs, tab, buttonGroup } from 'vue-strap'
    import VuePassword from 'vue-password'
    import MaskedInput from 'vue-masked-input'
    import axios from 'axios'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            'masked-input': MaskedInput,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup
        },
        name: 'signUp',
        metaInfo () {
            return {
                title: 'TONE | Redeem Your Gift',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Redeem Your Gift'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Redeem Your Gift'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                csv_file: [],
                userObject: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    packageId: 0,
                    comments: '',
                    phoneNumber: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
                },
                spinner: false,
                alert: false,
                passwordError: '',
                paymentSection: false,
                isToggle: false,
                isChecked: false,
                defaultPlan: '',
                hidePasswordMeter: true,
                rawPhoneNumber: '',
                phoneNumber: '',
                dynamic_bullet_1: '',
                dynamic_bullet_2: '',
                dynamic_bullet_3: '',
                dynamic_bullet_4: '',
                dynamic_bullet_5: '',
                dynamic_bullet_6: '',
                downloadUrl: window.location.href
            }
        },
        mounted () {
            if (this.user && (this.user.corporation && this.user.corporation.pageAdmin)) {
            } else {
                this.$router.push('/mytone')
            }
        },
        methods: {
            uploadImage () {
                console.log('csv file data', this.csv_file)
                this.$store.dispatch('UPLOAD_CORP_CSV_METADATA', {
                    csv_file: this.csv_file,
                    corporationId: this.user.corporation.corporationId,
                    userId: this.user.userId
                }).then((res) => {
                    if (res && res.completed && !res.error) {
                        this.showPopup('Success!', 'File is uploaded successfully', 'success')
                        this.$refs.myFileInput.value = ''
                        this.csv_file = []
                    } else {
                        this.showPopup('Error!', 'Unable to process.', 'error')
                    }
                }).catch(err => {
                    console.log('error', err)
                    this.showPopup('Error!', 'File could not be uploaded', 'error')
                })
            },
            showPopup (title, msg, popupType, cb) {
                this.$swal(title, msg, popupType).then(res => {
                    cb && cb()
                    return res
                })
            },
            onFileChange (event) {
                let files = event.target.files
                if (files.length) this.csv_file = files[0]
            },
            readCSVFile (file) {
                let self = this
                let reader = new FileReader()
                reader.readAsText(file)
                reader.onload = (e) => {
                    let contents = e.target.result
                    self.processCSVFile(contents)
                }
            },
            returnFormatedDate (delDate, format) {
//                let ddate = new Date(delDate + ' 00:00:00')
                let ddate = new Date(delDate.split('-').join('/'))
                // ddate.setDate(ddate.getDate() + 1)
                let dd = ddate.getDate()
                let mm = ddate.getMonth() + 1
                let yyyy = ddate.getFullYear()
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                if (format === 'M') {
                    return `${yyyy}-${mm}-${dd}`
                } else {
                    return `${mm}/${dd}/${yyyy}`
                }
            },
            processCSVFile (csv) {
                var allTextLines = csv.split(/\r\n|\n/)
                var lines = []
                for (var i = 1; i < allTextLines.length; i++) {
                    var data = allTextLines[i].split(',')
                    var tarr = []
                    for (var j = 0; j < data.length; j++) {
                        tarr.push(data[j])
                    }
                    lines.push(tarr)
                }
                console.log(lines)
                if (lines && lines.length > 0) {
                    for (var k = 0; k < lines.length; k++) {
                        let newGiftee = {}
                        newGiftee.packageId = this.packageId
                        newGiftee.gifteeFirstName = lines[k][0]
                        newGiftee.gifteeLastName = lines[k][1]
                        newGiftee.gifteeEmail = lines[k][2].toLowerCase()
                        newGiftee.deliveryMessage = lines[k][3]
                        newGiftee.deliveryDate = this.returnFormatedDate(lines[k][4], 'M')
                        newGiftee.redeemDate = null
                        this.gifteeCol.push(newGiftee)
                    }
                }
            },
            downloadWithAxios () {
                axios({
                    method: 'get',
                    url: this.returnDonwloadUrl(),
                    responseType: 'arraybuffer'
                }).then(response => {
                    console.log('response from axios', response)
                    this.forceFileDownload(response)
                }).catch(() => console.log('error occured'))
            },
            forceFileDownload (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'user-list.csv')
                document.body.appendChild(link)
                link.click()
            },
            downloadWithVueResource () {
                this.$http({
                    method: 'get',
                    url: this.url,
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        this.forceFileDownload(response)
                    })
                    .catch(() => console.log('error occured'))
            },
            returnDonwloadUrl () {
                let href = window.location.href
                let origin = ''
                if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                    origin = `https://api1.dev-tonenetworks.com/v1/corporations/downloadCorporationUsersCSV/${this.user.corporation.corporationId}/null/null`
                } else {
                    origin = `https://api1.tonenetworks.com/v1/corporations/downloadCorporationUsersCSV/${this.user.corporation.corporationId}/null/null`
                }
                // origin = 'https://78.media.tumblr.com/tumblr_m39nv7PcCU1r326q7o1_500.png'
                return origin
                // return `${this.downloadUrl}/downloadCorporationUsersCSV/${this.user.corporation.corporationId}/null/null`
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyPassword () {
                if (this.user.password.length >= 6) {
                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
                    if (!re.test(this.user.password)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    if (this.user.password.length > 0) {
                        return false
                    } else {
                        return true
                    }
                }
//                if (this.user.password.length >= 6) {
//                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
//                    if (!re.test(this.user.password)) {
//                        this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
            },
            verifyEmail () {
                if (this.user.email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(this.user.email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyFirstName () {
                if (this.user.firstName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.firstName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyLastName () {
                if (this.user.lastName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.lastName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyCardHolderName () {
                if (this.user.cardHolderName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.cardHolderName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onGifteeSubmit () {
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    this.user.phoneNumber = this.phoneNumber
                } else {
                    this.phoneNumber = ''
                    this.user.phoneNumber = ''
                }
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.spinnerToggle()
                    this.user.email = this.user.email.toLowerCase()
                    this.$store.dispatch('SAVEGIFTEE', {giftee: this.user}).then(() => {
                        if (!this.error.show) {
                            this.spinnerToggle()
                            this.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false,
                                customClass: 'sweetalert-lg-signup'
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        } else {
                            this.spinnerToggle()
                        }
                    })
                }
            }
        },
        computed: {...mapGetters([
            'user', 'error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getCorporateGiftingCode', 'getAllSiteContents'])
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .set-error{
        border-color: #a94442 !important;
        color:#a94442 !important;
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0 35px 35px;
        color: #f0617d;
    }
    .showmobile{
        display:none;
    }
    .stripeholder {
        position: relative;
    }

    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    @media (max-width:767px){
        .hidemobile{
            display:none;
        }
        .showmobile{
            display:inherit;
        }
        .signUp .left-content h4 {
            font-size: 14px;
            letter-spacing: 0px;
        }

        .signUp .main-content h2 {
            margin: 15px 0;
            line-height: 20px;
            font-size: 18px;
        }

        .signUp #redeem_pwderrormsg {
            margin-bottom: 8px;
            line-height: 1.3;
            letter-spacing: 1px;
        }

        .signUp .left-content .create-account #redeem_button {
            margin: 0;
        }

        .signUp .right-content .jumbotron {
            padding: 6px;
            margin-top: 7px;
        }

        .signUp .right-content .jumbotron h2 {
            margin: 0;
            font-size: 21px;
        }

        .signUp .right-content .jumbotron p {
            display: none;
        }

        .signUp .right-content .card {
            padding: 10px 10px;
        }

        .signUp .right-content .card .card-block .list-group li {
            font-size: 16px;
            margin: 0 0 10px;
        }

        .signUp .left-content hr {
            display: none;
        }

        .row.margin-top {
            margin-top: 0px;
        }

    }

    /* Media query for mobile viewport */
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /* Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    body .margin-top {
        margin-top: 89px;
        margin-bottom: 70px;
    }
    body .signUp .right-content .card .card-block .list-group{
        margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// ManagePage.vue?7b8ed344